import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../Axiosapi';
import env_constants from '../Constants';
import { AuthContext } from '../Context/AuthContext';
import { toast } from 'react-toastify';

const Address = () => {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);
    const [submitBtnText, setSubmitBtnText] = useState('Add Address');

    // Create a ref for the street address input
    const streetInputRef = useRef(null);

    const [formData, setFormData] = useState({
        f_name: '',
        l_name: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        suburb: '',
        post_code: '',
        street_address: '',
        address_type: '',
        company: '',
        user_id: user ? user.id : 0,
    });

    // Function to initialize Google Places Autocomplete
    useEffect(() => {
        if (window.google && streetInputRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(streetInputRef.current, {
                types: ["geocode"],
                componentRestrictions: { country: "AU" }, // Change country if needed
            });

            // Listen for place selection
            autocomplete.addListener("place_changed", () => handlePlaceSelect(autocomplete));
        }
    }, []);

    // Handle address selection from Google Places API
    const handlePlaceSelect = (autocomplete) => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        let street = "", city = "", state = "", suburb = "", postalCode = "";

        place.address_components.forEach((component) => {
            const componentType = component.types[0];

            switch (componentType) {
                case "street_number":
                    street = component.long_name + " " + street;
                    break;
                case "route":
                    street += component.long_name;
                    break;
                case "locality":
                    city = component.long_name;
                    break;
                case "administrative_area_level_1":
                    state = component.short_name;
                    break;
                case "sublocality_level_1":
                    suburb = component.long_name;
                    break;
                case "postal_code":
                    postalCode = component.long_name;
                    break;
                default:
                    break;
            }
        });

        const formattedAddress = place.formatted_address;

        setFormData((prev) => ({
            ...prev,
            street_address: formattedAddress,
            city: city,
            state: state,
            suburb: suburb,
            post_code: postalCode,
        }));

        // Update the street address input field manually
        if (streetInputRef.current) {
            streetInputRef.current.value = formattedAddress;
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitBtnText('Adding Address...');

        try {
            const response = await axios.post(`${env_constants.API_BASE_URL}/user-addresses/store`, formData);
            toast.success(response.data.message || 'Address Added Successfully!');
            navigate('/my-account');
        } catch (error) {
            setSubmitBtnText('Add Address');
            if (error.response) {
                const errorMessage = error.response.data.message || 'Failed to add address.';
                toast.error(errorMessage);
            } else if (error.request) {
                toast.error('No response from the server. Please check your internet connection.');
            } else {
                toast.error(`Error: ${error.message}`);
            }
        }
    };


    return (
        <div className="container my-5">
            <h1>Add New Address</h1>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <input type="text" name="f_name" value={formData.f_name} onChange={handleChange} placeholder="First Name" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-6">
                        <input type="text" name="l_name" value={formData.l_name} onChange={handleChange} placeholder="Last Name" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-6">
                        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-6">
                        <input type="number" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-3">
                        <input
                            type="text"
                            name="street_address"
                            placeholder="Street Address"
                            className="form-control mb-3"
                            onChange={handleChange}
                            ref={streetInputRef} // ✅ Attach ref for Google Autocomplete
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-3">
                        <input type="text" name="state" value={formData.state} onChange={handleChange} placeholder="State" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-3">
                        <input type="text" name="suburb" value={formData.suburb} onChange={handleChange} placeholder="Suburb" className="form-control mb-3" />
                    </div>
                    <div className="col-md-4">
                        <input type="number" name="post_code" value={formData.post_code} onChange={handleChange} placeholder="Post Code" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-4">
                        <input type="text" name="address_type" value={formData.address_type} onChange={handleChange} placeholder="Address Type" className="form-control mb-3" required />
                    </div>
                    <div className="col-md-4">
                        <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Company (Optional)" className="form-control mb-3" />
                    </div>
                    <div className="col-md-12">
                        <button type="submit" className="profile-edit-btn border-0">{submitBtnText}</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Address;
